import { mergeSymbolQuotes } from '../utils/symbolQuotes';
import React, { createContext, useContext, useEffect, useState } from 'react';
import APIMiddleware from '../data/api/Api-Middleware';
import { toast } from 'react-toastify';
import io from 'socket.io-client';
import i18n from '../i18n';
import {
  API_ENDPOINT_LEVERAGE,
  API_ENDPOINT_SYMBOLS,
  API_ENDPOINT_SESSION,
  API_ENDPOINT_SYMBOL_INFO,
  API_ENDPOINT_SESSION_DETAIL,
  API_ENDPOINT_EXCHANGE_RATE,
  notificationSystem,
} from '../data/Endpoints-API';

import { useAuthContext } from './Auth-Context';
import MarketUnitOptions from '../components/utils/MarketUnitOptions';
 
import axios from 'axios';
import { PromotionContext } from './promotionContext';
import { useAccountManagerContext } from './Account-Manager-Context';
import { shouldSwitchToParentOnChallengeLogout } from '../utils/challengeSwitchContext';
import { eaNotifySettingsChanged, eaNotifyChanged } from '../components/main/ea/eaApi.js';
import { localizeNotificationMessage } from '../i18n/notificationMessage.js';
import { translateFailReason } from '../i18n/apiDisplayLabels';
import { getFxQuoteAsset, hasTickFx } from '../utils/fxRate';

export const SymbolContext = createContext();

export const useSymbolContext = () => {
  return useContext(SymbolContext);
};

export const SymbolProvider = ({ children }) => {
  const {
    user,
    // updateUserAuthorization,
    selectedAuthSymbol,
    setAuthSelectedSymbol,
    setAuthSelectedCategory,
    setIsMariginCallVisible,
    allValidSymbols,
    platFromData,
    setSelectedAuthSymbolId,
    setReloadApi,
    logout,
    setVariantLogout,
    leverageData,
    fetchUserLeverage,
    switchToParentAccount,
    incrementSystemNotificationCount,
    setSystemNotificationCount
  } = useAuthContext();
  // Use i18n.t directly in socket handlers so language changes do not tear down sockets.
  const t = i18n.t.bind(i18n);
  const { setShowBank, setBankDetails, setAdminDepositPromo } = useAccountManagerContext();
  const { fetchUpdates } = useContext(PromotionContext);
  // Make Ripple Effect Function
  const mkRipple = (e, getColor) => {
    if (e.target.className != 'ripple_once') {
      const size = e.target.getClientRects()[0].width;
      const ripple = document.createElement('div');
      let color;
      if (getColor == undefined) {
        color = getComputedStyle(e.target).color;
      } else {
        color = getColor;
      }
      e.target.style.position = 'relative';
      e.target.style.overflow = 'hidden';
      ripple.className = 'ripple_once';
      ripple.style.transition = '.6s ease';
      ripple.style.backgroundColor = color;
      ripple.style.position = 'absolute';
      ripple.style.borderRadius = '100%';
      ripple.style.top = `${e.nativeEvent.offsetY - size / 2}px`;
      ripple.style.left = `${e.nativeEvent.offsetX - size / 2}px`;
      ripple.style.width = `${size}px`;
      ripple.style.height = `${size}px`;
      ripple.style.transform = 'scale(0)';
      ripple.style.opacity = 0.5;
      e.target.append(ripple);
      setTimeout(() => {
        ripple.style.transform = 'scale(2)';
        ripple.style.opacity = 0;
        setTimeout(() => {
          ripple.remove();
        }, 1000);
      }, 50);
    }
  };

  const [loadingSymbolContext, setLoadingSymbolContext] = useState(true);
  const [bidPrice, setBidPrice] = useState(null);
  const [askPrice, setAskPrice] = useState(null);
  const [bidPriceExchangeRate, setBidPriceExchangeRate] = useState(1);
  const [askPriceExchangeRate, setAskPriceExchangeRate] = useState(1);

  const [clickedPosition, setClickedPosition] = useState(false);

  // Debounce refs to prevent rapid-fire socket events
  const socketContextRef = React.useRef(null);
  const symbolDetailsTimerRef = React.useRef(null);
  const leverageUpdateTimerRef = React.useRef(null);
  const lastSymbolDetailsCallRef = React.useRef(0);
  const lastLeverageUpdateRef = React.useRef(0);

  //store list of all symbols
  const [symbolData, setSymbolData] = useState({});
  const [symbolNames, setSymbolNames] = useState([]);
  const [symbolWithCategories, setSymbolWithCategories] = useState({});
  const [symbolCategories, setSymbolCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(1);
  const [selectedSymbolSession, setSelectedSymbolSession] = useState(1);
  const [symbolInfo, setSymbolInfo] = useState({});
  const [symbolNumberFormat, setSymbolNumberFormat] = useState('#,###.00###');
  const [marketHours, setMarketHours] = useState({});
  const [showNetPnl, setShowNetPnl] = useState(true);
  const [showRLPnl, setShowRLPnl] = useState(true);
  const [showGrossPnl, setShowGrossPnl] = useState(true);
  const [leverage, setLeverage] = useState({});
  const [hideLeverageCard, setHideLeverageCard] = useState(false)
  const [symbolDetails, setsymbolDetails] = useState({});
  // The order picker follows the chart selection, including login/restoration
  // and alert-driven changes. Live quote refreshes never own this selection.
  const selectedSymbolOption = React.useMemo(() => {
    const value = selectedAuthSymbol || '';
    return { value, label: value };
  }, [selectedAuthSymbol]);
  const [newPositionOpen, setNewPositionOpen] = useState(false);
  const [quoteCurrency, setQuoteCurrency] = useState('');
  const [baseCurrency, setBaseCurrency] = useState('');
  const [lotSize, setLotSize] = useState(1);
  const [lotSteps, setLotSteps] = useState(0.0);
  const [unitOptions, setUnitOptions] = useState();
  const [fetchUserDetails, setFetchUserDetails] = useState("");
  const [fetchUserDetails2, setFetchUserDetails2] = useState("");
  const [selectedSymbolExchangeRate, setSymbolExchangeRate] = useState(1);
  const [selectedSymbolQuoteExchangeRate, setSymbolQuoteExchangeRate] =
    useState(1);
  const [isPositionEdited, setIsPositionEdited] = useState(false);
  const [activeLvg, setActiveLvg] = useState(null);
  const [showPriceAlert, setShowPriceAlert] = useState(false)
  const [priceAlertDetails, setPriceAlertDetails] = useState({
    symbol:"",
    quantity:1,
    title:'',
    description:"",
    readOnly:false,
  })
  
  const [showTooltip, setShowTooltip] = useState(false);
  const [currentExposureLevel, setCurrentExposureLevel] = useState(null);

  // ── Risk Profile state ──
  const [riskProfile, setRiskProfile] = useState(null);
  const [riskLocked, setRiskLocked] = useState(false);
  const riskProfileTimerRef = React.useRef(null);
  const lastRiskProfileUpdateRef = React.useRef(0);
  // Sync riskLocked & riskProfile from platFromData[5] (user_details via raw WebSocket)
  // This ensures correct state on page refresh / login (arrives on first tick)
  // Watch only primitive values to avoid infinite re-render loops
  const wsRiskLocked = platFromData?.[5]?.riskLocked;
  const wsRiskProfileId = platFromData?.[5]?.riskProfile?.id;
  const riskToastShownRef = React.useRef(false);
  const RISK_BREACH_TOAST_ID = 'risk-breach-lock-toast';

  useEffect(() => {
    if (wsRiskLocked !== undefined && wsRiskLocked !== riskLocked) {
      setRiskLocked(wsRiskLocked);
    }
    if (wsRiskLocked === false) {
      riskToastShownRef.current = false;
      toast.dismiss(RISK_BREACH_TOAST_ID);
    }
  }, [wsRiskLocked]);
  useEffect(() => {
    const wsProfile = platFromData?.[5]?.riskProfile;
    if (wsProfile !== undefined && wsProfile?.id !== riskProfile?.id) {
      setRiskProfile(wsProfile);
    }
  }, [wsRiskProfileId]);

  const [showBullets , setShowBullets] = useState(()=>{
    return localStorage.getItem('chartBullets') == 'true';
  });

  const allSymbolOptions =  symbolNames.map(( value) => ({
    value: value,
    label: value,

  }));


  const handleSymbolOptionChange = (selectedAuthSymbol) => {

    setSelectedCategoryId(symbolData[selectedAuthSymbol.value]?.symbol_category);
    setSelectedSymbolSession(symbolData[selectedAuthSymbol.value]?.is_session_active);
    setAuthSelectedCategory(symbolData[selectedAuthSymbol.value]?.symbol_category);
    setAuthSelectedSymbol(selectedAuthSymbol.value);

    localStorage.setItem('symbol_id', symbolData[selectedAuthSymbol.value]?.id);
    localStorage.setItem('category', symbolData[selectedAuthSymbol.value]?.symbol_category);

    // const { value, bid, ask, category, is_session_active } = selectedAuthSymbol;
    // updateSymbolData(value, bid, ask, category);
    // updateSymbolDetailsData(value)
  };

  useEffect(() => {
    localStorage.setItem("showTooltip", showTooltip);
  }, [showTooltip]);

  useEffect(()=>{
    localStorage.setItem('chartBullets',showBullets);
  },[showBullets])

  useEffect(() => {

    if (user && user.userId != undefined && user.userId > 0) {

      const logoutHandlingRef = { current: false };
      const refreshCurrentSymbolDetails = () => {
        const current = socketContextRef.current;
        if (current.selectedAuthSymbol) current.updateSymbolDetailsData(current.selectedAuthSymbol);
      };

      const isSocketEventForCurrentUser = (payload) => {
        if (!payload?.room || !payload?.userId) {
          return true;
        }

        const currentUserId = user?.userId?.toString();
        const targetUserId = payload.userId.toString();

        if (!currentUserId) {
          return false;
        }

        return (
          targetUserId === currentUserId ||
          targetUserId === `user_${currentUserId}`
        );
      };

      const handleForceLogout = async (eventData = {}) => {
        if (logoutHandlingRef.current) {
          return;
        }

        logoutHandlingRef.current = true;

        try {
          const reason = eventData?.reason;

          if (shouldSwitchToParentOnChallengeLogout(reason)) {
            toast.info(localizeNotificationMessage(eventData?.message || 'Returning to parent account...', t) || eventData?.message || t('notifications.msg.challengeEndedLogin'), {
              position: 'top-center',
              autoClose: 5000,
            });

            const switched = await socketContextRef.current.switchToParentAccount();
            if (switched) {
              return;
            }
          }

          await socketContextRef.current.logout();
        } catch (error) {
          console.error('[CHALLENGE] Force logout handler failed:', error);
          await socketContextRef.current.logout();
        } finally {
          logoutHandlingRef.current = false;
        }
      };

      // Initialize WebSocket connection
      const socketUrl = process.env.REACT_APP_SOCKET_URL;
      console.log('[LEV][WEB] initializing socket.io connection for symbols with URL:', socketUrl);
      const socket = io(socketUrl, {
        transports: ['websocket'],
      });

      // Handle WebSocket connection
      socket.on('connect', () => {
          const token = localStorage.getItem('token');
          if (!token || !user?.userId) {
            return;
          }
          socket.emit('joinRoom', { room: user.userId.toString(), token });
      });

      // Register custom event listeners
      socket.on('feedback_updated', (data) => {
        console.log('Received feedback_updated log:', data);
        if (data.display) {
          toast.success(localizeNotificationMessage(data.status, t));
        }
      });

      socket.on('sltpLog', (data) => {
        console.log('Received SLTP log:', data);
        if (data.display) {
          toast.warning(localizeNotificationMessage(data.status, t));
        }
      });

      socket.on('marginCallLog', (data) => {
        console.log('Received SLTP log:', data);
        if (data.display) {
          // toast.warning(`${data.status}`);
          setIsMariginCallVisible(true);
        }
      });
      socket.on('variant_logout', (data) => {
        const variant_id = localStorage.variantId;
        console.log(variant_id, 'Received variant_logout log:', data);
        if(variant_id == data.variant_id){
          setVariantLogout(true);
          setTimeout(() => {
            console.log("variant logout called===============================================================");
            socketContextRef.current.logout();
            setVariantLogout(false);
          }, 3000);
        }
        
      });

      socket.on('is_liquidate', (data) => {
        console.log('Received is_liquidate log:', data);
        if (data.display) {
          const liquidationAudio = document.getElementById('liquidationSound');
          if (liquidationAudio) {
            liquidationAudio.currentTime = 0;
            liquidationAudio.play().catch(() => {});
          }
          toast.warning(localizeNotificationMessage(data.status, t));
        }
      });
      socket.on('symbolsDetailsInfo', (data) => {
        const now = Date.now();
        const timeSinceLastCall = now - lastSymbolDetailsCallRef.current;
        
        console.log(socketContextRef.current.selectedAuthSymbol,'Received symbolsDetailsInfo updations:', data, 'Time since last:', timeSinceLastCall + 'ms');
        
        // Debounce: Only process if at least 500ms passed since last call
        if (timeSinceLastCall < 500) {
          console.log('[DEBOUNCE] symbolsDetailsInfo ignored - too soon after previous call');
          // Clear existing timer and set new one
          if (symbolDetailsTimerRef.current) {
            clearTimeout(symbolDetailsTimerRef.current);
          }
          symbolDetailsTimerRef.current = setTimeout(() => {
            setFetchUserDetails(Date.now());
            refreshCurrentSymbolDetails();
            lastSymbolDetailsCallRef.current = Date.now();
          }, 500);
          return;
        }
        
        // Clear any pending timer
        if (symbolDetailsTimerRef.current) {
          clearTimeout(symbolDetailsTimerRef.current);
        }
        
        lastSymbolDetailsCallRef.current = now;
        setFetchUserDetails(now);
        refreshCurrentSymbolDetails();
      });
      socket.on('userDetailsInfo', (data) => {
        setFetchUserDetails2(Date.now())
        console.log(socketContextRef.current.selectedAuthSymbol,'Received userDetailsInfo updations:', data);
      });
      socket.on('promotion_fetch', (data) => {
        console.log(socketContextRef.current.selectedAuthSymbol,'Received promotion_fetch updations:', data);
        socketContextRef.current.fetchUpdates();
      });
      socket.on('logout', async (data) => {
        await handleForceLogout(data || {});
      });

      // Challenge handlers must be defined before the message router references them.
      // Server wraps these in the generic `message` envelope; bare listeners cover direct emits.
      const challengeEventHandlers = {
        challenge_daily_profit_locked: (data) => {
          console.log('[CHALLENGE][WEB] Daily profit cap lock:', data);
          setRiskLocked(true);
          toast.warning(`🔒 ${localizeNotificationMessage(data?.message || 'Daily profit limit reached. Trading resumes tomorrow.', t)}`, {
            toastId: 'challenge_daily_profit_locked',
            autoClose: false,
            position: 'top-center'
          });
        },
        challenge_daily_profit_unlocked: (data) => {
          console.log('[CHALLENGE][WEB] Daily profit cap unlocked:', data);
          setRiskLocked(false);
          toast.dismiss('challenge_daily_profit_locked');
          toast.success(`🔓 ${localizeNotificationMessage(data?.message || 'New trading day! Account unlocked.', t)}`, {
            toastId: 'challenge_daily_profit_unlocked',
            autoClose: 5000,
            position: 'top-center'
          });
        },
        challenge_failed: (data) => {
          console.log('[CHALLENGE][WEB] Challenge failed:', data);
          const reason =
            translateFailReason(data?.fail_reason, t) ||
            t('notifications.msg.failReasonFallback');
          toast.error(
            `❌ ${t('notifications.msg.challengeFailedToast', { reason })}`,
            { toastId: 'challenge_failed', autoClose: false, position: 'top-center' }
          );
        },
        challenge_phase_passed: (data) => {
          console.log('[CHALLENGE][WEB] Phase passed:', data);
          toast.success(
            `🎉 ${t('notifications.msg.challengePhasePassedToast')}`,
            { toastId: 'challenge_phase_passed', autoClose: false, position: 'top-center' }
          );
        },
        challenge_completed: (data) => {
          console.log('[CHALLENGE][WEB] Challenge completed:', data);
          toast.success(
            `🏆 ${t('notifications.msg.challengeCompletedToast')}`,
            { toastId: 'challenge_completed', autoClose: false, position: 'top-center' }
          );
        },
      };

      Object.entries(challengeEventHandlers).forEach(([eventName, handler]) => {
        socket.on(eventName, handler);
      });

      socket.on('message', async (payload) => {
        if (!payload?.emitter) {
          return;
        }

        // SocketSync unwraps message→named events; this path covers direct io (:8801) or midware gaps.
        const eaMessageHandlers = {
          eaSettingsChanged: () => eaNotifySettingsChanged(),
          eaStrategiesChanged: (data) => {
            console.log('[EA][WEB] eaStrategiesChanged via message:', data);
            eaNotifyChanged();
          },
        };

        const isRoutedEmitter =
          payload.emitter === 'logout' ||
          !!challengeEventHandlers[payload.emitter] ||
          !!eaMessageHandlers[payload.emitter];

        if (!isRoutedEmitter) {
          return;
        }

        if (!isSocketEventForCurrentUser(payload)) {
          return;
        }

        if (payload.emitter === 'logout') {
          await handleForceLogout(payload.data || {});
          return;
        }

        if (eaMessageHandlers[payload.emitter]) {
          eaMessageHandlers[payload.emitter](payload.data || {});
          return;
        }

        challengeEventHandlers[payload.emitter](payload.data || {});
      });
      socket.on('system_notification_fetch', (data) => {
        setReloadApi(Date.now());
        const eventUserIds = Array.isArray(data?.userIds) ? data.userIds.map((id) => Number(id)) : [];
        const shouldIncrement =
          eventUserIds.length === 0 || eventUserIds.includes(Number(user?.userId));
        if (shouldIncrement) {
          incrementSystemNotificationCount();
          APIMiddleware.post(notificationSystem(), { userId: user?.userId })
            .then((response) => {
              if (typeof response?.data?.unseenCount !== 'undefined') {
                setSystemNotificationCount(response.data.unseenCount);
              }
            })
            .catch((error) => {
              console.error('Failed to sync unseen system notification count', error);
            });
        }
        console.log('Received system_notification_fetch:', data);
        toast.info(t('notifications.msg.newSystemNotification'), {
          position: "top-right",
          autoClose: 5000,
        });
      });

      // Handle WebSocket connection errors
      socket.on('connect_error', (err) => {
        console.error('Connection errorsss:', err);
      });
      socket.on('show_bank_details', (data) => {
        setShowBank(true);
        if(data?.bank_info){
          setBankDetails(data?.bank_info);
        }
        console.log('notification received',data);
      });

      socket.on('leverageUpdated', (data) => {
        const now = Date.now();
        const timeSinceLastUpdate = now - lastLeverageUpdateRef.current;
        
        console.log('[LEV][WEB] socket leverageUpdated received:', {
          raw: data,
          userId: user?.userId,
          selectedAuthSymbol: socketContextRef.current.selectedAuthSymbol,
          symbolName: data?.symbolName,
          timeSinceLastUpdate: timeSinceLastUpdate + 'ms',
          socketUrl,
        });

        // Debounce: Only process if at least 300ms passed since last update
        if (timeSinceLastUpdate < 300) {
          console.log('[DEBOUNCE] leverageUpdated ignored - too soon after previous update');
          // Set timer to process after debounce period
          if (leverageUpdateTimerRef.current) {
            clearTimeout(leverageUpdateTimerRef.current);
          }
          leverageUpdateTimerRef.current = setTimeout(() => {
            document.dispatchEvent(new CustomEvent('ws_message_platform', {
              detail: {
                type: 'leverageUpdated',
                userId: user?.userId,
                symbolName: data?.symbolName || null,
                timestamp: Date.now()
              }
            }));
            lastLeverageUpdateRef.current = Date.now();
          }, 300);
          return;
        }

        // Clear any pending timer
        if (leverageUpdateTimerRef.current) {
          clearTimeout(leverageUpdateTimerRef.current);
        }

        lastLeverageUpdateRef.current = now;

        // Dispatch custom DOM event that Auth-Context.js listens for
        document.dispatchEvent(new CustomEvent('ws_message_platform', {
          detail: {
            type: 'leverageUpdated',
            userId: user?.userId,
            symbolName: data?.symbolName || null,
            timestamp: data?.timestamp || now
          }
        }));

        console.log('[LEV][WEB] dispatched leverageUpdated ws_message_platform event:', {
          userId: user?.userId,
          symbolName: data?.symbolName || null,
          socketUrl,
        });
      });

      socket.on('eaSettingsChanged', (data) => {
        console.log('[EA][WEB] eaSettingsChanged received:', data);
        eaNotifySettingsChanged();
      });

      socket.on('eaStrategiesChanged', (data) => {
        console.log('[EA][WEB] eaStrategiesChanged received:', data);
        eaNotifyChanged();
      });

      socket.on('price_drop_alert', (data) => {
        console.log(data.price_drop_data.symbol_name,'Received:', data);

        const matchingSymbol = socketContextRef.current.symbolWithCategories.find(
          (symbol) => symbol.name == data.price_drop_data.symbol_name,
        );
        
        console.log(matchingSymbol,"matchingSymbolmatchingSymbolmatchingSymbolmatchingSymbol")
        if (matchingSymbol) {

          localStorage.setItem('symbol_id', matchingSymbol.id);
          localStorage.setItem('category', matchingSymbol.symbol_category);
          localStorage.setItem('symbol', matchingSymbol.name);

          setSelectedCategoryId(matchingSymbol.symbol_category);
          setAuthSelectedCategory(matchingSymbol.symbol_category);
          setSelectedSymbolSession(matchingSymbol.is_session_active);
          socketContextRef.current.updateSymbolName(matchingSymbol.name);
          setAuthSelectedSymbol(matchingSymbol.name);

          setShowPriceAlert(true);
          setPriceAlertDetails({ symbol:data.price_drop_data.symbol_name,
            quantity:data.price_drop_data.quantity,
            title:data.price_drop_data.title,
            description:data.price_drop_data.comment,
            readOnly:data.price_drop_data.quantity_change == 'false'
          })

      }
      });

      socket.on('deposit_promo_alert', (data) => {
        const promo = data?.deposit_promo_data;
        const description = promo?.description || promo?.message || promo?.comment;
        if (!description) {
          return;
        }
        setAdminDepositPromo({
          title: promo?.title ? String(promo.title) : null,
          message: String(description),
        });
      });

      // ── Risk Profile Updated ──
      socket.on('riskProfileUpdated', (data) => {
        const now = Date.now();
        const timeSinceLastUpdate = now - lastRiskProfileUpdateRef.current;

        console.log('[RISK][WEB] riskProfileUpdated received:', data);

        // Debounce: 300ms
        if (timeSinceLastUpdate < 300) {
          if (riskProfileTimerRef.current) clearTimeout(riskProfileTimerRef.current);
          riskProfileTimerRef.current = setTimeout(() => {
            setRiskProfile(data?.riskProfile || null);
            lastRiskProfileUpdateRef.current = Date.now();
          }, 300);
          return;
        }

        if (riskProfileTimerRef.current) clearTimeout(riskProfileTimerRef.current);
        lastRiskProfileUpdateRef.current = now;
        setRiskProfile(data?.riskProfile || null);
      });

      // ── Risk Breach (immediate lock) ──
      socket.on('riskBreach', (data) => {
        console.log('[RISK][WEB] riskBreach received:', data);
        const reasons = data?.reasons?.join(', ') || 'Unknown breach';
        setRiskLocked(true);
        if (!riskToastShownRef.current) {
          riskToastShownRef.current = true;
          toast.error(`🔒 Account locked! Risk breach – ${reasons}`, {
            toastId: RISK_BREACH_TOAST_ID,
            autoClose: false,
            position: 'top-center'
          });
        } else {
          toast.update(RISK_BREACH_TOAST_ID, {
            render: `🔒 Account locked! Risk breach – ${reasons}`,
            autoClose: false,
            position: 'top-center',
            type: toast.TYPE.ERROR
          });
        }
      });

      // ── Risk Reactivated (admin unlocks account) ──
      socket.on('riskReactivated', (data) => {
        console.log('[RISK][WEB] riskReactivated received:', data);
        setRiskLocked(false);
        riskToastShownRef.current = false;
        toast.dismiss(RISK_BREACH_TOAST_ID);
        toast.success('✅ Account reactivated! Trading is enabled again.', {
          autoClose: 5000,
          position: 'top-center'
        });
      });

      // Cleanup WebSocket connection on component unmount
      return () => {
        // Clear any pending timers
        if (symbolDetailsTimerRef.current) {
          clearTimeout(symbolDetailsTimerRef.current);
        }
        if (leverageUpdateTimerRef.current) {
          clearTimeout(leverageUpdateTimerRef.current);
        }
        if (riskProfileTimerRef.current) {
          clearTimeout(riskProfileTimerRef.current);
        }
        
        socket.disconnect();
        console.log('Socket disconnected and timers cleared');
      };
    }
  }, [user?.userId]);
  useEffect(() => {
    if (user && user.userId != undefined && user.userId > 0) {
      loadSymbolName();
    }
  }, [allValidSymbols]);

  // const loadSymbolName = async () => {
  //   // get symbols by api
  //   // const response = await APIMiddleware.get(API_ENDPOINT_SYMBOLS(user.userId));
  //   // if (response.data) {
  //     // Extracting symbols names
  //     const symbolNames = allValidSymbols[0].map(symbol => symbol.name);
  //     if(localStorage.symbol == null){
  //     setAuthSelectedSymbol(symbolNames[0]);
  //       allValidSymbols[0].map((symbol)=>{
  //         if(symbol.name === symbolNames[0]){
  //           setSelectedCategoryId(symbol.symbol_category);
  //           setAuthSelectedCategory(symbol.symbol_category);
  //           setSelectedSymbolSession(symbol.is_session_active);
  //         }
  //     })
  //       // setSelectedCategoryId(symbolNames[0][0].symbol_category);
  //       // setAuthSelectedCategory(symbolNames[0][0].symbol_category);
  //       // setSelectedSymbolSession(symbolNames[0][0].is_session_active);

  //     }else{
  //       setAuthSelectedSymbol(current => symbolNames.some(item => item.name === current) ? current : localStorage.symbol);
  //       allValidSymbols[0].map((symbol)=>{
  //           if(symbol.name === localStorage.symbol){
  //             setSelectedCategoryId(symbol.symbol_category);
  //             setAuthSelectedCategory(symbol.symbol_category);
  //             setSelectedSymbolSession(symbol.is_session_active);
  //           }
  //       })
  //     }
  //     setSymbolNames(symbolNames);

  //     setSymbolWithCategories(allValidSymbols[0]);
  //     setSymbolCategories(allValidSymbols[1]);
  //     const symbolDetailsData = {};

  //     //setting initial values to all symbols
  //     allValidSymbols[0].forEach((symbol) => {
  //         symbolDetailsData[symbol.name] = { pip_position: symbol.pip_position, digit: symbol.digit, symbol_category: symbol.symbol_category, is_session_active: symbol.is_session_active};
  //     });

  //     setsymbolDetails(symbolDetailsData);

  //     setLoadingSymbolContext(false);
  //   // }
  // }

  // Update leverage and settings when leverageData changes
  // leverageData is now a single object (not array) for the selected symbol only
  useEffect(() => {
    if (leverageData && leverageData.symbol_name === selectedAuthSymbol) {
      console.log('[LEV] Updating leverage state for symbol:', selectedAuthSymbol, {
        symbol_is_hidden: leverageData.symbol_is_hidden,
        group_is_hidden: leverageData.group_is_hidden,
      });
      
      // Set leverage array (for backward compatibility with existing code)
      // The leverage card expects an array with the full leverage object
      setLeverage([leverageData]);
      
      // Set visibility and PNL settings
      // hideLeverageCard should be false when leverage is NOT hidden (is_hidden === 1 means hidden, so show when is_hidden !== 1)
      // Note: hideLeverageCard is used as "show card" in Order-Panel.tsx (confusing naming)
      const shouldHide = !(leverageData.symbol_is_hidden === 1 || leverageData.group_is_hidden === 1);
      setHideLeverageCard(shouldHide);
      setShowGrossPnl(leverageData.show_gross_pnl === 1);
      setShowNetPnl(leverageData.show_net_pnl === 1);
      setShowRLPnl(leverageData.show_todayRlPNL === 1);
      
      console.log('[LEV] Leverage state updated:', {
        shouldShowCard: shouldHide,
        showGrossPnl: leverageData.show_gross_pnl === 1,
        showNetPnl: leverageData.show_net_pnl === 1,
      });
    } else if (leverageData && leverageData.symbol_name !== selectedAuthSymbol) {
      // Don't reset if data is for different symbol - wait for correct data
      console.log('[LEV] Ignoring leverage data for different symbol:', {
        dataFor: leverageData.symbol_name,
        currentSymbol: selectedAuthSymbol,
      });
    } else {
      // Only reset if truly no data (not just wrong symbol)
      console.log('[LEV] No leverage data available for:', selectedAuthSymbol);
      setLeverage([]);
    }
  }, [leverageData, selectedAuthSymbol]);

  // Fetch leverage when symbol changes (removed fetchUserLeverage from deps to prevent infinite loop)
  useEffect(() => {
    if (user?.userId && selectedAuthSymbol) {
      fetchUserLeverage(user.userId, selectedAuthSymbol);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userId, selectedAuthSymbol]);

  
  
  const selectedTickFx = { ea: askPriceExchangeRate, eb: bidPriceExchangeRate };
  const selectedUsesTickFx = hasTickFx(selectedTickFx);

  useEffect(() => {
    let active = true;
    
        if (user && user.userId != undefined && user.userId > 0 && symbolInfo.quote_asset) {
          calculateApiExchangeRate(() => active);
          calculateQuoteApiExchangeRate(() => active);
    
        } 
        return () => { active = false; };
      }, [ user, symbolInfo, selectedUsesTickFx]);

  const calculateExchangeRate = (quotePrice, accPrice) => {
    return quotePrice / accPrice;
  };
  const calculateQuoteExchangeRate = (quotePrice, accPrice) => {
    return accPrice / quotePrice;
  };


  const calculateApiExchangeRate = (isCurrent = () => true) => {
      
    const userCurrency = (user?.userCurrencyName || "EUR").toUpperCase();
    const qoute = getFxQuoteAsset(symbolInfo.quote_asset, selectedTickFx);
    
    console.log("[Exchange Rate Check] symbolInfo.quote_asset:", symbolInfo.quote_asset, "=> Quote:", qoute, "User Currency:", userCurrency, "Match:", qoute === userCurrency);
    
    // Skip API call if quote currency matches user currency (never EUR-hardcoded)
    if (qoute === userCurrency) {
      console.log("✓ Skip exchange rate for", symbolInfo.quote_asset, "- Setting rate to 1");
      setSymbolExchangeRate(1);
      return;
    }
    
    const payload = { quotation: qoute };
    // Prefer TDS in-memory cache (same source as fills/opens); env host is optional fallback only
    const urls = [
      API_ENDPOINT_EXCHANGE_RATE(),
      process.env.REACT_APP_EXCHANGE_RATE_API,
    ].filter(Boolean);

    const tryNext = (i) => {
      if (!isCurrent()) return;
      if (i >= urls.length) {
        setSymbolExchangeRate(1);
        console.error("Error fetching exchange rate from all sources", urls, payload);
        return;
      }
      axios.post(urls[i], payload)
        .then((response) => {
          if (!isCurrent()) return;
          const data = response.data;
          if (response.status == 204) {
            tryNext(i + 1);
          } else if (data) {
            const rate = data[userCurrency];
            if (rate) setSymbolExchangeRate(rate);
            else tryNext(i + 1);
          } else {
            tryNext(i + 1);
          }
        })
        .catch(() => tryNext(i + 1));
    };
    tryNext(0);
  };

  //Calculates exchange rate in quote currency of selected symbol 
  const calculateQuoteApiExchangeRate = (isCurrent = () => true) => {
      
    const userCurrency = (user?.userCurrencyName || "EUR").toUpperCase();
    const qoute = getFxQuoteAsset(symbolInfo.quote_asset, selectedTickFx);
    
    console.log("[Quote Exchange Rate Check] Quote:", qoute, "User Currency:", userCurrency, "Match:", qoute === userCurrency);
    
    // Skip API call if quote currency matches user currency
    if (qoute === userCurrency) {
      console.log("✓ Skip quote exchange rate for", symbolInfo.quote_asset, "- Setting rate to 1");
      setSymbolQuoteExchangeRate(1);
      return;
    }
    
    const payload = { quotation: qoute };
    // Same failover as calculateApiExchangeRate: TDS first, env host second
    const urls = [
      API_ENDPOINT_EXCHANGE_RATE(),
      process.env.REACT_APP_EXCHANGE_RATE_API,
    ].filter(Boolean);

    const tryNext = (i) => {
      if (!isCurrent()) return;
      if (i >= urls.length) {
        setSymbolQuoteExchangeRate(1);
        console.error("Error fetching quote exchange rate from all sources", urls, payload);
        return;
      }
      axios.post(urls[i], payload)
        .then((response) => {
          if (!isCurrent()) return;
          const data = response.data;
          if (response.status == 204) {
            tryNext(i + 1);
          } else if (data) {
            const rate = data[userCurrency];
            if (rate) setSymbolQuoteExchangeRate(1 / rate);
            else tryNext(i + 1);
          } else {
            tryNext(i + 1);
          }
        })
        .catch(() => tryNext(i + 1));
    };
    tryNext(0);
  };

  const loadSymbolName = async () => {
    // get symbols by api
    // const response = await APIMiddleware.get(API_ENDPOINT_SYMBOLS(user.userId));
    // if (response.data) {
    // Extracting symbols names
    const symbolNames = allValidSymbols[0].map((symbol) => symbol);
    if (localStorage.symbol == null) {
      // console.log(symbolNames[0].symbol_category,symbolNames[0].name)
      setAuthSelectedSymbol(symbolNames[0].name);
      setSelectedAuthSymbolId(symbolNames[0].id);
      setSelectedCategoryId(symbolNames[0].symbol_category);
      setAuthSelectedCategory(symbolNames[0].symbol_category);
      setSelectedSymbolSession(symbolNames[0].is_session_active);
    } else {
      setAuthSelectedSymbol(localStorage.symbol);
      setSelectedAuthSymbolId(localStorage.symbol_id);
      allValidSymbols[0].map((symbol) => {
        if (symbol.name === localStorage.symbol) {
          setSelectedCategoryId(symbol.symbol_category);
          setAuthSelectedCategory(symbol.symbol_category);
          setSelectedSymbolSession(symbol.is_session_active);
        }
      });
    }
    setSymbolNames(symbolNames.map((symbol) => symbol.name));

    setSymbolWithCategories(allValidSymbols[0]);
    setSymbolCategories(allValidSymbols[1]);
    const symbolDetailsData = {};

    //setting initial values to all symbols
    allValidSymbols[0].forEach((symbol) => {
      symbolDetailsData[symbol.name] = {
        pip_position: symbol.pip_position,
        digit: symbol.digit,
        symbol_category: symbol.symbol_category,
        is_session_active: symbol.is_session_active,
      };
    });

    setsymbolDetails(symbolDetailsData);

    setLoadingSymbolContext(false);
    // }
  };

  const loadAllSymbolsData = (data) => {
    setSymbolData(previous => mergeSymbolQuotes(previous, data));
 
  };
  //update symbols default values
  const updateSymbolData = (symbol,ea,eb, bid, ask,is_session_active, select = true) => {
    // Market ticks refresh quotes; only an explicit selection may change the chart.
    if (!select && socketContextRef.current.selectedAuthSymbol !== symbol) return;
    if (select) setAuthSelectedSymbol(symbol);
    if (!select) setSymbolData(prev => {
      const current = prev[symbol];
      if (current?.bid === bid && current?.ask === ask) return prev;
      return {...prev, [symbol]: {...current, bid, ask}};
    });
    setBidPrice(bid);
    setAskPrice(ask);
    setBidPriceExchangeRate(eb);
    setAskPriceExchangeRate(ea);
    setSelectedSymbolSession(is_session_active);
    // updateSymbolInfo(symbol);
    // updateMarketHours(symbol);
    // updateLeverage(symbol);
  };

  //update symbols lev/ mkt hours etc
  const updateSymbolDetailsData = (symbol) => {
    // updateLeverage(symbol);
    updateSymbolInfo(symbol);
    // updateMarketHours(symbol);
  };

  const updateSymbolName = (symbol) => {
    setAuthSelectedSymbol(symbol);
  };

  const symbolInfoRequestRef = React.useRef(0);
  const updateSymbolInfo = async (symbol) => {
    const request = ++symbolInfoRequestRef.current;
    const accountId = user?.userId;
    try {
      if (user && user.userId != undefined && user.userId > 0) {
        // get the selected symbol's info using param and return that data in setSymbolInfo as param to show on frontend

        const parts = symbol.split('USD');
        const quoteAsset = 'USD';
        const baseAsset = parts[0];
        const response = await APIMiddleware.get(
          API_ENDPOINT_SYMBOL_INFO(user.userId, symbol),
        );
        if (request !== symbolInfoRequestRef.current || socketContextRef.current.selectedAuthSymbol !== symbol || socketContextRef.current.user?.userId !== accountId) return;
        const responseData = response.data[0];
        const symbolInfo = {
          base_asset: responseData.base_asset
            ? responseData.base_asset
            : baseAsset,
          quote_asset: responseData.quote_asset
            ? responseData.quote_asset
            : quoteAsset,
          pip_position: responseData.pip_position,
          lot_size:
            responseData.lot_size <= 0 || !responseData.lot_size
              ? 100000
              : responseData.lot_size,
          trade_type: responseData.trade_type || 'units',
          // swap_long: 1111,
          // swap_short: 1111,
          // three_day_swaps: 1111,
          swap_long: responseData.swap_long,
          swap_short: responseData.swap_short,
          three_day_swaps: responseData.three_days_swap,
          digit: responseData.digit,
          asset_name: responseData.asset_name || 'Cryptocurrencies',
          asset_id: responseData.asset_id || 2,
          show_stop_out_details : responseData.show_stop_out_details,
          weekend_swap : responseData.weekend_swap,
          swap_time : responseData.swap_time,
          swap_period : responseData.swap_period,
          grace_period : responseData.grace_period,
          hide_swap_details : responseData.hide_swap_details
        };
        setSymbolInfo(symbolInfo);
        console.log("[Symbol Info Updated]", symbol, "Quote:", symbolInfo.quote_asset, "Base:", symbolInfo.base_asset);
        setSymbolNumberFormat(
          parseFloat(symbolInfo.digit)
            ? `#,###.${'0'.repeat(symbolInfo.digit)}`
            : `#,###.00`,
        );
        setQuoteCurrency(symbolInfo?.quote_asset);
        setBaseCurrency(symbolInfo?.base_asset);
        setLotSize(symbolInfo?.lot_size);

        setUnitOptions(MarketUnitOptions[symbolInfo.asset_name]);

        let miniLotSize = process.env.REACT_APP_LOT_SIZE || 10000;
        let result = parseFloat(miniLotSize) / parseFloat(symbolInfo?.lot_size);

        let step = 1;
        let stepArr = [];
        while (step <= 10) {
          // Corrected loop condition
          let lotSteps = (result * step).toFixed(8);
          stepArr.push({ label: lotSteps + ' ' + 'Lots', value: lotSteps });
          step++;
        }

        setLotSteps(stepArr);
      }
    } catch (error) {
      // Handle API request error
      console.error(`API request error: ${API_ENDPOINT_SYMBOL_INFO}`, error);
    }
  };

  const updateMarketHours = async (symbol) => {
    try {
      if (user && user.userId !== undefined && user.userId > 0) {
        const response = await APIMiddleware.get(
          API_ENDPOINT_SESSION_DETAIL(user.userId, symbol),
        );
        const marketHours = response.data.map((rowData) => {
          const isActive = rowData.is_active === 1; // Convert 1 to true, 0 to false
          return {
            start_day: rowData.start_day,
            start_time: rowData.start_time,
            end_day: rowData.end_day,
            end_time: rowData.end_time,
            is_active: isActive,
          };
        });

        setMarketHours(marketHours);
      }
    } catch (error) {
      // Handle API request error
      console.error(`API request error: ${API_ENDPOINT_SESSION_DETAIL}`, error);
    }
  };

  const updateLeverage = async (symbol) => {
    try {
      if (user && user.userId != undefined && user.userId > 0) {
        const response = await APIMiddleware.get(
          API_ENDPOINT_LEVERAGE(user.userId, symbol),
        );
        const responseData = response.data[0];
        const leverage = [
          {
            exposure_level: responseData.exposure_level
              ? responseData?.exposure_level?.toString()
              : 0,
            available_leverage: responseData?.available_leverage?.toString(),
            is_hidden: responseData.is_hidden,
          },
        ];

        setLeverage(leverage);
        setShowGrossPnl(responseData?.show_gross_pnl == 1 ? true : false);
        setShowNetPnl(responseData?.show_net_pnl == 1 ? true : false);
        setShowRLPnl(responseData?.show_todayRlPNL == 1 ? true : false);
      }
    } catch (error) {
      // Handle API request error
      console.error(`API request error: ${API_ENDPOINT_LEVERAGE}`, error);
    }
  };

  // Keep account socket handlers current without reconnecting on symbol changes.
  React.useLayoutEffect(() => {
    socketContextRef.current = {
      user, selectedAuthSymbol, symbolWithCategories: Array.isArray(symbolWithCategories) ? symbolWithCategories : [],
      updateSymbolDetailsData, updateSymbolName, fetchUpdates, switchToParentAccount, logout,
    };
  });

  return (
    <SymbolContext.Provider
      value={{
        clickedPosition, setClickedPosition,
        showTooltip, setShowTooltip,
        showBullets, setShowBullets,
        loadingSymbolContext,
        symbolData,
        bidPrice,
        askPrice,
        askPriceExchangeRate,
        bidPriceExchangeRate,
        symbolNames,
        symbolInfo,
        marketHours,
        leverage,
        allSymbolOptions,
        selectedSymbolOption,
        symbolDetails,
        newPositionOpen,
        setNewPositionOpen,
        isPositionEdited,
        setIsPositionEdited,
        loadAllSymbolsData,
        updateSymbolData,
        updateSymbolName,
        handleSymbolOptionChange,
        mkRipple,
        updateSymbolDetailsData,
        setLoadingSymbolContext,
        symbolWithCategories,
        symbolCategories,
        selectedCategoryId,
        setSelectedCategoryId,
        selectedSymbolSession,
        setSelectedSymbolSession,
        baseCurrency,
        quoteCurrency,
        selectedSymbolQuoteExchangeRate,
        selectedSymbolExchangeRate,
        symbolNumberFormat,
        setSymbolNumberFormat,
        lotSize,
        setLotSize,
        lotSteps,
        unitOptions,
        showGrossPnl,
        showNetPnl,
        showRLPnl,
        hideLeverageCard,
        activeLvg,
        setActiveLvg,
        showPriceAlert,
        setShowPriceAlert,
        priceAlertDetails,
        setPriceAlertDetails,
        fetchUserDetails,
        fetchUserDetails2,
        currentExposureLevel,
        setCurrentExposureLevel,
        riskProfile,
        riskLocked,
        setRiskLocked
      }}
    >
      {children}
    </SymbolContext.Provider>
  );
};
